module.exports = __webpack_public_path__ + "static/plane-5debabd12e84eeb3b3d32b329b6bb3be.png";